import {Injectable} from '@angular/core';
import {HashService} from "../hash.service";

@Injectable({
    providedIn: 'root'
})
export class GpuFingerprintService {

  constructor (
    private hashService: HashService,
  ) {
  }

  async identity(): Promise<any> {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      canvas.width = 4;
      canvas.height = 4;

      canvas.style.position = 'fixed';
      canvas.style.top = '-999px';
      canvas.style.opacity = '0.01';
      document.body.appendChild(canvas);

      const gl = (canvas.getContext('webgl2') ||
        canvas.getContext('webgl') ||
        canvas.getContext('experimental-webgl')) as WebGLRenderingContext | null;

      if (!gl) {
        canvas.remove();
        return resolve({ status: 'webgl_not_supported', gpu_id: '' });
      }

      const vsSource = `
        attribute vec2 position;
        void main() { gl_Position = vec4(position, 0.0, 1.0); }
    `;

      const fsSource = `
        precision highp float;
        void main() {
            vec2 coord = gl_FragCoord.xy / 4.0;
            float r = fract(sin(coord.x * 12.9898) * 43758.5453);
            float g = fract(cos(coord.y * 78.233) * 23421.6312);
            gl_FragColor = vec4(r, g, fract(r + g), 1.0);
        }
    `;

      function createShader(glContext: WebGLRenderingContext, type: number, source: string): WebGLShader | null {
        const shader = glContext.createShader(type);
        if (!shader) return null;
        glContext.shaderSource(shader, source);
        glContext.compileShader(shader);
        return glContext.getShaderParameter(shader, glContext.COMPILE_STATUS) ? shader : null;
      }

      const vs = createShader(gl, gl.VERTEX_SHADER, vsSource);
      const fs = createShader(gl, gl.FRAGMENT_SHADER, fsSource);

      if (!vs || !fs) {
        canvas.remove();
        return resolve({ status: 'shader_failed', gpu_id: '' });
      }

      const program = gl.createProgram();
      if (!program) {
        canvas.remove();
        return resolve({ status: 'program_failed', gpu_id: '' });
      }

      gl.attachShader(program, vs);
      gl.attachShader(program, fs);
      gl.linkProgram(program);
      gl.useProgram(program);

      const vertices = new Float32Array([-1,-1, 1,-1, -1,1, -1,1, 1,-1, 1,1]);
      const buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);

      const positionLocation = gl.getAttribLocation(program, 'position');
      gl.enableVertexAttribArray(positionLocation);
      gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);

      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.drawArrays(gl.TRIANGLES, 0, 6);

      requestAnimationFrame(async () => {
        try {
          const pixels = new Uint8Array(4 * 4 * 4);
          gl.readPixels(0, 0, 4, 4, gl.RGBA, gl.UNSIGNED_BYTE, pixels);

          gl.deleteBuffer(buffer);
          gl.deleteProgram(program);
          gl.deleteShader(vs);
          gl.deleteShader(fs);
          canvas.remove();

          const pixelsString = pixels.join(',');

          resolve({
            status: 'success',
            gpu_id: this.hashService.sha256(pixelsString)
          });
        } catch (e) {
          canvas.remove();
          resolve({ status: 'compromised', gpu_id: 'blocked_bypass' });
        }
      });
    });
  }

}
